import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import type { ChannelDashboardOverview } from '@troia-v3/types';

export const ProfileHeader: React.FC<{ channel: ChannelDashboardOverview['channel'] }> = ({ channel }) => {
  const info = channel.accountInfo;
  const name = info?.verifiedName || info?.businessName || info?.pushName || channel.name;
  const initials = name.slice(0, 2).toUpperCase();
  const platform = info?.platform || channel.providerId?.replace('-messaging', '') || '';
  const meta = [platform, info?.category].filter(Boolean).join(' · ');
  return (
    <div className="cdash-profile" data-testid="cdash-profile">
      <div className="cdash-av">
        {info?.profilePictureUrl ? <img src={info.profilePictureUrl} alt={name} /> : <span>{initials}</span>}
      </div>
      <div>
        <div className="cdash-pname">
          {name}
          {info?.verifiedName ? (
            <span className="cdash-verified" title="Conta verificada">
              <FiCheckCircle size={16} />
            </span>
          ) : null}
        </div>
        <div className="cdash-phandle">@{channel.identifier}</div>
        {meta ? <span className="cdash-ppill">{meta}</span> : null}
      </div>
    </div>
  );
};
